import axios from 'axios';
import { logout } from './userActions';

const FRONTEND_AUTH_ERROR_CODES = new Set([1001, 1002, 1003]);

const hasAuthErrorCodePrefix = (message) => {
	if (typeof message !== 'string') return false;
	const match = message.trim().match(/^([0-9]+)\s*-\s+/);
	if (!match) return false;
	return FRONTEND_AUTH_ERROR_CODES.has(Number(match[1]));
};

const isAuthErrorResponse = (data) => {
	if (!data || typeof data !== 'object') return false;
	if (data.session_expired === true) return true;
	if (FRONTEND_AUTH_ERROR_CODES.has(Number(data.error_code))) return true;
	if (hasAuthErrorCodePrefix(data.msg)) return true;
	return false;
};

export const getBacNETData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/bacnet`, config);

		// const data = {
		// 	BacNETRequestCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'Fucntion Code',
		// 		'NPDU Code',
		// 		'APDU Type',
		// 		'Command',
		// 		'Version',
		// 		'Seen By'
		// 	],
		// 	BacNETRequestRows: [],
		// 	status: true
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};

export const getDNP3Data = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/dnp3`, config);

		// const data = {
		// 	DNP3RequestCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'PacketSource',
		// 		'PacketDestination',
		// 		'ControlCodes',
		// 		'Command',
		// 		'ObjectCode',
		// 		'Seen By'
		// 	],
		// 	DNP3RequestRows: [],
		// 	status: true
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};

export const getModbusData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/modbus`, config);
		// const data = {
		// 	ModbusRequestCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'Unit ID',
		// 		'Fucntion Code',
		// 		'Response',
		// 		'Seen By'
		// 	],
		// 	ModbusRequestRows: [ [ '211.110.12.203', '211.110.12.202' ], [ '122.194.229.49', '211.110.12.201' ] ],
		// 	ModbusResponseCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'Unit ID',
		// 		'Fucntion Code',
		// 		'Seen By'
		// 	],
		// 	ModbusResponseRows: [ [ '211.110.12.203', '122.194.229.48' ], [ '122.194.229.49', '122.194.229.50' ] ],
		// 	status: true
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};

export const getS7CommsData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/s7comms`, config);
		// const data = {
		// 	S7CommsResponseCols: [
		// 		'Time Stamp res',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'ROSCTR',
		// 		'Lenght',
		// 		'Fucntion Code',
		// 		'Seen By'
		// 	],
		// 	S7CommsRequestCols: [
		// 		'Time Stamp req',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Mac',
		// 		'Source Vendor',
		// 		'Destination IP',
		// 		'Destination MAC',
		// 		'Destination Device',
		// 		'ROSCTR',
		// 		'Lenght',
		// 		'Fucntion Code',
		// 		'Seen By'
		// 	],
		// 	S7CommsRequestRows: [ [ '211.110.12.203 req', '122.194.229.48' ], [ '122.194.229.49', '122.194.229.50' ] ],
		// 	S7CommsResponseRows: [ [ '211.110.12.203 res', '122.194.229.48' ], [ '122.194.229.49', '122.194.229.50' ] ],
		// 	status: true
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};

export const getOTSettingsData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/otapproved`, config);
		// const data = {
		// 	CommandsCols: [ 'Commands', 'Actions' ],
		// 	CommandsRow: [ [ '211.110.12.203 req' ], [ '122.194.229.49' ] ],
		// 	status: true
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};

export const addOTSettingsData = (formData) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.post(`/api/otapproved`, formData, config);

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			if (isAuthErrorResponse(data)) {
				dispatch(logout());
			}
			return data;
		} else {
			return {};
		}
	} catch (err) {
		if (err?.response && [401, 403].includes(err.response.status)) {
			dispatch(logout());
		}
		return {};
	}
};
